





























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import loadingService from "@/service/loadingService";
import { MESSAGE } from "@/model/Message";
import { Action, Getter } from "vuex-class";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import Number from "@/shared/filters/Number";

@Component({
  components: {
    ConfirmDialog,
  },
  filters: {
    Number
  }
})
export default class NextageFooter extends Vue {

  @Prop({ default: false }) frontPage: boolean; // 車検識別する最初のページ=起点画面で呼び出された場合は動作が異なる

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  @Getter("couponLabel", { namespace: "FunctionSetting" })
  couponLabel: string;
  @Getter("optionLabel", { namespace: "FunctionSetting" })
  optionLabel: string;
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  reqService: requestService;
  loadingService: loadingService;
  showDialog: boolean = false;
  errorMessage: string = "";
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  loading: boolean = false;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  loadingText: string = MESSAGE.Loading;
  isUserMode: boolean = false;
  isDispNICS: boolean = false;

  shakenShurui: any = [];

  scenarioList: any = [];
  scenarioSelection: number = 0;
  scenarioMax: number = 3;
  confirmDialogNexInspectMsg: string = "";
  nextUketsukeCd: string = "";

  $refs!: {
    sendNexDialog: ConfirmDialog;
    goNextReservation: ConfirmDialog;
    sendNexDialogEnd: ConfirmDialog;
  };

  created() {
    if (this.$route.meta == "user") {
      this.isUserMode = true;
    } else if ( this.$route.name == "customer") {
      // 工場側の顧客詳細画面では表示しない
      this.isDispNICS = true;
    }
    this.reqService = new requestService();
    this.loadingService = new loadingService();
  //  if ( this.uketsukeExtendsId != null ) {
  //    this.$set(this, "loading", true);
  //    this.getScenarioList(this.uketsukeExtendsId,"");
  //  }
  }

//  mounted() {
  //  if ( this.uketsukeExtendsId != null ) {
  //    this.$set(this, "loading", true);
  //    this.getScenarioList(this.uketsukeExtendsId,"");
  //  }
//  }

  getScenarioList(uketsukeExtendsId: number, endMsg: string) {// 文字ではなくID
    this.reqService.getReservationTarget(uketsukeExtendsId,1).then(
      (res: any) => {
        this.$set(this, "loading", false);
      //  console.log("res",res);
        res.forEach((e: any, i: number) => {
          if ( e.uketsukeCd == e.uketsukeParentCd || e.uketsukeParentCd == "") {
            this.scenarioSelection = i;
          }
        });
        this.$set(this, "scenarioList", res);
        if ( this.scenarioList.length > 3 ) {
          this.scenarioMax = 0;
        } else {
          this.scenarioMax = 3 - this.scenarioList.length;
        }
        // 終了メッセージの指定があるときはウインドウを表示する
        if (endMsg != "") {
          this.confirmDialogNexInspectMsg = endMsg;
          this.$refs.sendNexDialogEnd.onOpen();
        }
      },
      (err: any) => {
        this.scenarioSelection = -1;
        this.$set(this, "scenarioList", []);
        // 終了メッセージの指定があるときはウインドウを表示する
        if (endMsg != "") {
          this.confirmDialogNexInspectMsg = endMsg;
          this.$refs.sendNexDialogEnd.onOpen();
        }
      }
    );
  }

  // selShakenShurui(code: string) {
  //  this.shakenShurui.map((data: any) => {
  //  });
  // }

  selectScenario(uketsukeCd: string) {
    this.$set(this, "loading", true);
  // this.uketsukeExtendsId
   this.reqService.changeReservationTarget(uketsukeCd).then(
      (res: any) => {
        this.reqService.openedReservationTarget(
          res.sknUketsukeExtends.id,
          {
            "pgtypeKbn" : "select",
            "assignKbn" : this.isUserMode ? "user" : "factory"
          }
        );

        // 画面維持->リスト更新
        // this.getScenarioList(res.sknUketsukeExtends.id,"");
        // this.confirmDialogNexInspectMsg = "車検を切り替えました";
        // this.$refs.sendNexDialogEnd.onOpen();

        // 画面遷移->確認モーダル
        this.$set(this, "loading", false);
        this.nextUketsukeCd = res.uketsuke.uketsukeCd;
        this.confirmDialogNexInspectMsg = "車検を切り替えます";
        this.$refs.goNextReservation.onOpen();
        
      },
      (err: any) => {
        this.scenarioSelection = 0;
        this.$set(this, "scenarioList", []);
      }
   );
  }

  copyScenario(uketsukeCd: string) { // 複製
  this.$set(this, "loading", true);
   this.reqService.copyReservationTarget(uketsukeCd,"").then(// ここもコードじゃなくなる
      (res: any) => {
        
        // 画面維持->リスト更新
        // this.$set(this, "loading", false); // getScenarioListで止める
        this.getScenarioList(res.sknUketsukeExtends.id,"複製しました");
        // this.confirmDialogNexInspectMsg = "複製しました";
        // this.$refs.sendNexDialogEnd.onOpen();

        // 画面遷移->確認モーダル
        // this.nextUketsukeCd = res.uketsuke.uketsukeCd;
        // this.confirmDialogNexInspectMsg = "複製しました";
        // this.$refs.goNextReservation.onOpen();

      //  let shakenShuruiSeibiMenuCd = this.seibiMenuCd;
      //  let isSaved = shakenShuruiSeibiMenuCd != "";
      //  res.map((data: any) => {
      //    if (isSaved && shakenShuruiSeibiMenuCd == data.seibiMenuCd) {
      //      data.selected = "1";
      //    } else {
      //      data.selected = "0";
      //    }
      //  });
      //  this.$set(this, "shakenShurui", res);
      },
      (err: any) => {
      //  this.$set(this, "shakenShurui", []);
        this.$set(this, "loading", false);
        this.confirmDialogNexInspectMsg = "複製で問題が発生しました.";
        this.$refs.sendNexDialogEnd.onOpen();
      }
    );
  }

  delScenario(uketsukeCd: string) { // onClose()参照？ 削除
  this.$set(this, "loading", true);
   this.reqService.deleteReservationTarget(uketsukeCd).then(
      (res: any) => {
        if ( this.scenarioList[this.scenarioSelection].uketsukeCd == uketsukeCd ) {
          this.$set(this, "loading", false);
          // 画面遷移->確認モーダル
          this.nextUketsukeCd = res.uketsuke.uketsukeCd;
          this.confirmDialogNexInspectMsg = "削除しました。車検を切り替えます";
          this.$refs.goNextReservation.onOpen();
        } else {
          // this.$set(this, "loading", false); // getScenarioListで止める
          // 画面維持->リスト更新 (遷移不要時は空文字で返ってくる)
          this.getScenarioList(res.sknUketsukeExtends.id,"削除しました");
          // this.confirmDialogNexInspectMsg = "削除しました";
          // this.$refs.sendNexDialogEnd.onOpen();
        }
      },
      (err: any) => {
        if ( err.status == 204 ) {
          this.$set(this, "loading", false);
          if ( this.scenarioList[this.scenarioSelection].uketsukeCd == uketsukeCd ) {
            if ( this.scenarioSelection > 0 ) {
              // 画面遷移->確認モーダル
              // 本当は遷移先の情報がBEから送られる必要があるのだが。。。
              this.nextUketsukeCd = this.scenarioList[this.scenarioSelection - 1].uketsukeCd;
              this.confirmDialogNexInspectMsg = "削除しました。車検を切り替えます.";
              this.$refs.goNextReservation.onOpen();
            } else {
              // 画面維持->リスト更新 (遷移不要時は空文字で返ってくる)
              // this.getScenarioList(this.uketsukeExtendsId,"削除しました.");新しいExtendsIdは不明且つ、何を表示すべきかもわからない
              this.confirmDialogNexInspectMsg = "削除しました.";
              this.$refs.sendNexDialogEnd.onOpen();
            }
            
          } else {
            // 画面維持->リスト更新 (遷移不要時は空文字で返ってくる)
            // this.getScenarioList(this.uketsukeExtendsId,"削除しました");新しいExtendsIdは不明
            this.confirmDialogNexInspectMsg = "削除しました";
            this.$refs.sendNexDialogEnd.onOpen();
          }
          
          
        }
      }
    );
  }

  onOpenScenario() {
    this.showDialog = true;
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.$nextTick(()=> {
      if ( this.uketsukeExtendsId != null ) {
        this.$set(this, "loading", true);
        this.getScenarioList(this.uketsukeExtendsId,"");
      }
    });
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
    this.errorMessage = "";
  }

  onCloseScenario() {
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.$set(this, "loading", false);
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
    this.showDialog = false;
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  setLoading(b: any) {
    this.$set(this, "loading", b);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  goNextReservation() {
    // 車検切り替えの簡易実装
    // if (e) {
    //  e.stopPropagation();
    // }
    // if (row.progressKbn != 3) {
    //  this.clearState();
    //  this.clearStateInspectionDetail();
    //  this.clearStateTime();
    //  this.clearStateInspect();
    //  this.clearStateCarSelection();
    //  this.clearStateWorkOrder();
    //  this.setUketsukeCd(row.uketsukeCd);
    this.onCloseScenario(); // モーダルを閉じる
    if (this.isUserMode) {
      this.$router.push({
        name: "usercustomer",
        params: { code: this.yoyakuNo }
      });
    } else {
      if ( this.frontPage ) {
        // 同じページに飛ぶのでhistoryを汚さないようにする
        this.$router.replace({
        // this.$router.push({
          name: "customer",
          params: { code: this.nextUketsukeCd }
        });

      } else {
        this.$router.push({
          name: "customer",
          params: { code: this.nextUketsukeCd }
        });
      }
      
    }
      
    // }
  }

  onSendNexInspection() {
    this.confirmDialogNexInspectMsg = "車検データの送信を行いますか？";
    this.$refs.sendNexDialog.onOpen();
  }

  sendNexInspection() {
    this.loadingService.show();

    this.reqService.sendNexInspection(this.uketsukeExtendsId).then((res: any) => {
    // this.reqService.sendNexInspection(1).then((res: any) => {
      if ( typeof(res) == "object" ) {
        // 推定 JSON : (NICSからエラー原因が送られた場合の処理)
        let plusMessage = "";
        if ( res.hosoku ) {
          plusMessage = res.hosoku; // res.resultCodeは現状使わない
        } else {
          plusMessage = "不明なエラー";
        }
        this.loadingService.hide();
        this.confirmDialogNexInspectMsg = "NICS送信に失敗しました<br /><br />" + plusMessage;
        this.$refs.sendNexDialogEnd.onOpen();
      } else {
        // 推定 number 「200」:成功
        this.loadingService.hide();
        this.confirmDialogNexInspectMsg = "NICS送信完了";
        this.$refs.sendNexDialogEnd.onOpen();
      }
    },
      (err: any) => {
        // NICSから返答なかった時、その前に到達しなかったときなど致命的なエラーが出た時
        this.loadingService.hide();
        this.confirmDialogNexInspectMsg = "NICS送信に失敗しました";
        this.$refs.sendNexDialogEnd.onOpen();
      }
    );
    
  }
}
